import { useQuery } from '@apollo/client';
import type { BillingCycle } from '@interfaces/billingCycle';
import dayjs from 'dayjs';
import { useParams } from 'react-router';
import { useLocalization } from '../../hooks/useLocalization';

import { FETCH_BILLING_CYCLE_BREADCRUMB } from './feeReportBreadcrumb.query';

export const FeeReportBreadcrumb = () => {
  const { translateBackendString, localizedDate } = useLocalization();

  const { data } = useQuery(FETCH_BILLING_CYCLE_BREADCRUMB, {
    variables: { billingCycleId: useParams().billingCycleId },
  });
  const billingCycle: BillingCycle | undefined =
    data?.fetchBillingCycle?.billingCycle;
  if (!billingCycle) return '';

  return `${translateBackendString(billingCycle.organization?.translatedName)} ${
    billingCycle?.startDate && billingCycle?.endDate
      ? `(${localizedDate(billingCycle.startDate)} - ${localizedDate(dayjs(billingCycle.endDate).subtract(1, 'day'))})`
      : ''
  }`;
};
